/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:34 PM
 * To change this template use File | Settings | File Templates.
 */



define(function (require) {
    "use strict";
    var ArticleContainerLayout = require("connection-views/layouts/ArticleContainerLayout");
    var ExpandedArticleModel = require("connection-models/ExpandedArticleModel");
    var RelatedCollection = require("connection-collections/ArticlesRelatedCollection");
    var ExpandedArticleView = require("connection-views/article/ExpandedArticleView");
    var RelatedCompositeView = require("connection-views/article/RelatedCompositeView");
    var SnippetModel = require("connection-models/KPsTab/SnippetModel");
    var Storage = require("assets/js/storage");
    var CP_CONST = require("connection-const");

    var LEResourceResolver = require("leResourceResolver");
    var DomUtilities = require("infra-util/DomUtilities");

    var Loader = require("ui/loader/Loader");

    var ArticleContainerController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        ArticleContainerController = Marionette.Controller.extend({
            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.isTrial = LE.context.get("user.isTrial");
                this.ticketContainerChannel = LEConnection.media.channel(LE.mediaCodes.connection.channels.CONTENT_CONTAINER);
                this._createArticleLayout();
                this._setEventListeners();
            },

            _launchYoutube: function () {
                var youtubeUrl = LEResourceResolver.getUrl(LEResourceResolver.apiResources.YouTube);
                DomUtilities.addScriptTag(youtubeUrl);
            },

            _setEventListeners: function () {
                this.listenTo(this.articleContainerLayout, "articleContainerController:closeArticle", this._setArticleClosed);
                this.listenTo(this.connectionPanelContextModel, 'change:selectedKP', this._onChangeSelectedKP);
                this.listenToOnce(this.connectionPanelContextModel, 'change:selectedKP', this._launchYoutube);
                this.listenTo(this.connectionPanelContextModel,"change:topElement",this._onTopElementChange);
                this.listenTo(this.articleContainerLayout, "render",  this._onLayoutRender);
                this.listenTo(LEConnection.vent, 'article:error',  this._onError);
                this.listenTo(LEConnection.vent, 'layout:domain:ready',  this._setArticleLayout);
                this.listenTo(LEConnection.vent, 'nodata:click:refresh',  this._saveSlugToStorage);
                this.listenTo(this.connectionPanelContextModel, "change:ticketViewIsOpen change:extendedViewIsOpen", this._onTicketStatusChanged);
            },

            _createArticleLayout: function () {
                this.articleContainerLayout = new ArticleContainerLayout({
                    model: this.connectionPanelContextModel
                });
            },

            _setArticleLayout: function (el) {
                LEConnection.vent.trigger("ConnectionPanelLayoutController:showRegion:Article", {
                    view: this.articleContainerLayout
                });
            },

            _onTopElementChange: function(){
                this.articleContainerLayout.setOnTop(this.connectionPanelContextModel.getTopElement()===CP_CONST.PAGE.ARTICLE);
            },

            _onTicketStatusChanged: function () {
                var isTicketViewOpen = this.connectionPanelContextModel.isTicketViewOpen() || false,
                    isListViewOpen = this.connectionPanelContextModel.isTicketListOpen() || false;
                this.articleContainerLayout.setArticleContainerLocation(isListViewOpen, isTicketViewOpen);
            },

            _onChangeSelectedKP: function (contextModel, selectedKP) {
                if (selectedKP) {
                    this._displayContent(selectedKP);
                }
                else {
                    this._hideArticleContainerLayout();
                    Storage.remove("connectionPanel_slug");
                }
            },

            _displayContent: function(selectedKP){
                this._toggleLayout();
                this.fetchExpandedArticle(selectedKP);
            },

            _onError: function () {
                this._saveSlugToStorage(true);
                this._toggleLayout();
                this._cleanup();
                this._showNoData();
            },

            _setArticleClosed: function () {
                LEConnection.trigger("kpSnippet:selected",{
                    snippetModel:null,
                    type:null
                });
                this._hideArticleContainerLayout();
                LEConnection.vent.trigger("article:close");
                LEConnection.vent.trigger("storage:save:selectedKP", this.connectionPanelContextModel, this.connectionPanelContextModel.get("selectedKP"));
            },

            _toggleLayout: function () {
                _.defer(_.bind(function () {
                    this.articleContainerLayout.toggleArticlePanel(true);
                }, this));
            },

            _showArticleIfAvailable: function () {
                var selectedKP = this.connectionPanelContextModel.get("selectedKP");
                if(selectedKP){
                    this._displayContent(selectedKP);
                }
            },

            _hideArticleContainerLayout: function () {
                this._stopVideo();
                this.articleContainerLayout.toggleArticlePanel(false);
                LEConnection.vent.trigger("ConnectionPanelLayoutController:hideRegion:Article");
            },

            _showRegion: function (region, view) {
                region.show(view);
            },

            _stopVideo: function() {
                try{
                    if (window.player && window.player.stopVideo){
                        window.player.stopVideo();
                    }
                }catch(err) {}
            },

            _onLayoutRender: function () {
                this._showArticleIfAvailable();
            },

            //------------------------------------------------------------
            // Expanded Article Logic
            //------------------------------------------------------------

            fetchExpandedArticle: function (model) {
                this._resetLayout();
                this._showLoader();
                this._getExpandedArticleModel().fetch({
                    slug: model.get("slug"),
                    lang: this.connectionPanelContextModel.get("locale"),
                    referrerAction: this.connectionPanelContextModel.get("referrerAction"),
                    userId: this.connectionPanelContextModel.get("userId"),
                    persona: this.connectionPanelContextModel.get("persona"),
                    accountId: this.connectionPanelContextModel.get("accountId"),
                    isTrial:  this.isTrial,
                    success: _.bind(this._onExpandedFetchSuccess, this),
                    error: _.bind(this._onError, this)
                });
            },

            _onExpandedFetchSuccess: function (model, resp, options) {

                if(_.isEmpty(resp)) {
                    this._onError();
                    return;
                }
                LEConnection.vent.trigger("recentSnippetsCollection:fetch:success");

                this._cleanup();
                this._saveSlugToStorage();
                this.renderExpandedArticleView();
                this._showRelatedContent({
                    slug: options.slug,
                    lang: options.lang
                });

            },

            _saveSlugToStorage: function (reset) {

                var slug = reset ? "null" : this._getCurrentSlug();
                Storage.set("connectionPanel_slug", slug);
            },

            renderExpandedArticleView:function(){
                if(!this.expandedArticleView ) {
                    this.expandedArticleView = this._getExpandedArticleView();
                }
                this.articleContainerLayout.expandedArticleRegion.show(this.expandedArticleView);
            },

            _getExpandedArticleModel: function () {
                if (!this.expandedArticleModel) {
                    this.expandedArticleModel = new ExpandedArticleModel();
                }
                return this.expandedArticleModel;
            },

            _getExpandedArticleView: function () {
                if(!this.expandedArticleView){
                    this.expandedArticleView = new ExpandedArticleView({
                        model:this._getExpandedArticleModel()
                    });
                }
                return this.expandedArticleView;
            },

            _cleanup: function () {
                this._stopVideo();
                this._hideNoData();
                this._closeLoader();
            },

            _resetLayout: function () {
                this.articleContainerLayout.expandedArticleRegion.reset();
                this.articleContainerLayout.relatedRegion.reset();
            },

            //------------------------------------------------------------
            // Related Logic
            //------------------------------------------------------------

            _showRelatedContent: function (options) {
                this.relatedCollection = this._getRelatedCollection();

                this.relatedCollection.fetch({
                    slug: options.slug,
                    lang: options.lang,
                    success: _.bind(this._onRelatedFetchSuccess, this),
                    error: _.bind(this.onRelatedFetchError, this)
                });
            },

            _getRelatedCollection: function () {
                if(!this.relatedCollection){
                    this.relatedCollection = new RelatedCollection();
                }
                return this.relatedCollection;
            },

            _onRelatedFetchSuccess: function (collection) {
                if(!collection.isEmpty()){
                    var relatedCompositeView = this._getRelatedCompositeView(collection);
                    this._showRegion(this.articleContainerLayout.relatedRegion, relatedCompositeView);
                }
            },

            _getRelatedCompositeView: function (collection) {
                if(!this.relatedCompositeView){
                    this.relatedCompositeView = new RelatedCompositeView({
                        collection:collection
                    });
                }
                return this.relatedCompositeView;

            },

            onRelatedFetchError: function () {
                // TODO: add error
            },

            //------------------------------------------------------------
            // Loader Logic
            //------------------------------------------------------------

            _closeLoader: function () {
                if(this.loader) {
                    this.loader.close();
                }
            },
            _showLoader: function () {
                this.loader = new Loader({
                    permutation: Loader.PERMUTATION.G,
                    el: this.articleContainerLayout.ui.expandedArticle
                });
                this.loader.render();
            },

            //------------------------------------------------------------
            // No Data
            //------------------------------------------------------------

            _showNoData: function () {
                this.articleContainerLayout.toggleNoData(false);
            },
            _hideNoData:function(){
                this.articleContainerLayout.toggleNoData(true);
            },


            //------------------------------------------------------------
            // Helpers
            //------------------------------------------------------------

            _isAlreadyShowingCurrentSlug: function (slug) {
                var result = false;
                var currentSlug = this._getCurrentSlug();

                if(currentSlug === slug) {
                    result = true;
                }

                return result;
            },

            _getCurrentSlug: function () {
                var result;
                var selectedKP = this.connectionPanelContextModel.get("selectedKP");

                if(selectedKP) {
                    result = selectedKP.get("slug");
                }
                return result;
            }

        });
    });

    return ArticleContainerController;
});
